import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("noi_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function saveAuth(token, user) {
  localStorage.setItem("noi_token", token);
  localStorage.setItem("noi_user", JSON.stringify(user));
}
export function clearAuth() {
  localStorage.removeItem("noi_token");
  localStorage.removeItem("noi_user");
}
export function getUser() {
  try { return JSON.parse(localStorage.getItem("noi_user")); } catch { return null; }
}
export function getToken() {
  return localStorage.getItem("noi_token");
}

export function fmtErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(", ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

// Normalise FastAPI 422 validation errors (detail is an array of objects) into
// a plain string BEFORE it reaches component code. Any callsite doing
// `toast.error(e.response?.data?.detail || "...")` is now safe — no React
// "Objects are not valid as a React child" crash on Pydantic validation errors.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    try {
      const data = error?.response?.data;
      if (data && data.detail != null && typeof data.detail !== "string") {
        data.detail = fmtErr(data.detail);
      }
    } catch { /* swallow — never let interceptor crash the app */ }
    return Promise.reject(error);
  },
);
